<template>
  <v-container fluid class="main-invest-user-offer-container">
    <v-simple-table class="table-invest-user-offer">
      <template v-slot:default>
        <!-- <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Calories</th>
          </tr>
        </thead> -->
        <tbody>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.name')}}</td>
            <td>{{ invest.id }}</td>
          </tr>
          <tr v-if="invest.offer.rating">
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.rating')}}</td>
            <td>
              <v-chip
                class="ma-2"
                :color="getRatingColor(invest.offer.rating)"
                ttext-color="white"
                :text-color="getRatingColor(invest.offer.rating, 'text')"
              >
              {{$t('components.invest.infoUserOffer.rating')}}
                <v-avatar
                  right
                  :class="getRatingColor(invest.offer.rating, 'avatar_color')"
                  style="width: auto !important"
                  >{{ invest.offer.rating_str }}</v-avatar
                >
              </v-chip>
            </td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.from')}}</td>
            <td>
               <span v-if="invest.clientCompany">{{ invest.clientCompany.organization_short_name }}</span>
               <span v-if="invest.clientPhysical">{{ invest.clientPhysical.full_name }}</span>
            </td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.contact')}}</td>
            <td>{{ invest.user.full_name }}</td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.createdAt')}}</td>
            <td>{{ invest.created_at | formatDate }}</td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.priceInvest')}}</td>
            <td>{{ invest.price | formatPrice }}</td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.period')}}</td>
            <td>{{ invest.month }} {{$t('components.invest.infoUserOffer.month')}}</td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.percent')}}</td>
            <td>{{ invest.percent }} %</td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.payOutType')}}</td>
            <td>
              <span v-if="invest.payout_type == 1">{{$t("utilsData.statuses.split.payoutTypeList.1")}}</span>
              <span v-else>{{$t("utilsData.statuses.split.payoutTypeList.4")}}</span>
            </td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.profit')}}</td>
            <td>
              {{ invest.profit | formatPrice }} /
              {{ invest.profit_each_month | formatPrice }} {{$t('components.invest.infoUserOffer.month')}}
            </td>
          </tr>
          <tr>
            <td class="font-weight-light">{{$t('components.invest.infoUserOffer.status')}}</td>
            <td>
              <v-chip
                :color="getStatusUserColor(invest.status)"
                :text-color="getStatusUserTextColor(invest.status)"
                >{{ getStatusUserName(invest.status) }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import formatPrice from "@/mixins/filters/formatPrice";
import formatDate from "@/mixins/filters/formatDate";
import statusNames from "@/utils/data/statuses";

export default {
  name: "InfoUserOffer",
  //directives: { mask },
  mixins: [formatPrice, formatDate],
  data: () => ({
    statusNames,
  }),

  props: {
    invest: Object,
  },
  components: {},

  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
    }),
  },

  methods: {
    getStatusUserColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].color
        ? this.statusNames.investUserDefault[id].color
        : "";
    },
    getStatusUserTextColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].textColor
        ? this.statusNames.investUserDefault[id].textColor
        : "";
    },
    getStatusUserName(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].name
        ? this.statusNames.investUserDefault[id].name
        : "";
    },

    getRatingColor(rating, param = "color") {
      return this.getStatusParam(rating, param, "investRating");
    },
    getStatusParam(id, param, paramObject = "investRating") {
      if (id === null) return;
      if (!param) return;
      let statusObj = this.__getStatusObj(paramObject);
      if (!statusObj) return;
      return statusObj[id][param] ? statusObj[id][param] : "";
    },

    __getStatusObj(objName) {
      if (!this.statusNames) return null;
      if (this.statusNames[objName]) return this.statusNames[objName];
      return null;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" >
// .v-data-table {
//   &.table-invest-user-offer {
//     table {
//       width: auto !important;
//     }
//   }
// }
</style>
